import classNames from "classnames";
import { FieldState } from "formstate";
import React from "react";
import { CheckBoxInputFieldState } from "@fidget/common/components/form/checkboxInput";
import { intl } from "@fidget/common/i18n/TypedIntl";
import styles from "../../taggingSettings.css";

interface Props {
  id: string;
  field: FieldState<boolean>;
  noMarginBottom?: boolean;
}
export const ActiveCheckbox = ({ id, field, noMarginBottom }: Props) => {
  return (
    <div className={classNames(styles["inputs-container"], styles["checkbox-input"])}>
      <CheckBoxInputFieldState
        field={field}
        id={`enabled-${id}`}
        label={intl.formatMessage("settings.tagging.mapping.enabled")}
        smallStyle
        displayNoColors
        noMarginBottom={noMarginBottom}
      />
    </div>
  );
};
